export function onlyDigits(value: string): string {
  return value.replace(/\D/g, '');
}

export function toE164Phone(value: string, isBrazil: boolean): string {
  const digits = onlyDigits(value);
  if (isBrazil && (digits.length === 10 || digits.length === 11)) {
    return `+55${digits}`;
  }
  return value.trim().startsWith('+') ? `+${digits}` : digits;
}
